import * as React from 'react';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../reducers';
import ResourceCreationPanel from '../ResourceCreationPanel';
import { createFolder, closePanel, setName } from '../../containers/FolderCreationPanel/actions';

export interface FolderCreationPanelProps {
	isOpen: boolean;
	name: string;
	useSelection: boolean;
	dispatch: Dispatch<StoreState>;
}

const FolderCreationPanel = ({ isOpen, name, useSelection, dispatch }: FolderCreationPanelProps) => {
	const fieldsConfig = {
		name: {
			value: name,
		},
	};

	return (
		<ResourceCreationPanel
			isOpen={isOpen}
			gallerySlot="folderCreationPanel"
			icon="iconset_doc_default"
			fields={fieldsConfig}
			onFieldChange={(name, value) => dispatch(setName(value))}
			onConfirm={({ name }) => dispatch(createFolder(name.value, useSelection))}
			onCancel={() => dispatch(closePanel())}
		/>
	);
};

export default FolderCreationPanel;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/FolderCreationPanel/index.tsx